import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InventorySource, ShipmentDetail, ShipmentDetailAllocation } from 'src/app/acumatica/EntityServices/OrderPicking.service';
import { StockItem } from 'src/app/acumatica/EntityServices/StockItem.service';

@Component({
  templateUrl: './pick-detail-editor.component.html',
  styleUrls: ['./pick-detail-editor.component.css']
})
export class PickDetailEditorComponent {

  editingEstablishedPick!: boolean;
  allocation!: ShipmentDetailAllocation;
  get detail(): ShipmentDetail { return this.allocation.shipmentDetail; }
  get item(): StockItem { return this.allocation.shipmentDetail.item!; }
  get source(): InventorySource { return this.allocation.source!; }

  /** the open quantity for the ShipmentDetail line without the allocation currently being edited */
  get openOrderQty(): number { return this.detail.OpenQty + (this.allocation.FulfillmentQty || 0); }
  /** boolean value indicating if the current allocation can have Allowances added to it */
  get canHaveAllowances(): boolean { return !this.detail.ShipFullRolls; }
  /** boolean value indicating if the current allocation can be set to Ship Full Rolls */
  get canShipFullRoll(): boolean { return this.item.isRolledGood && !this.allocation.AnyAllowances && !this.detail.PreAllocation; }
  /** the overage quantity that has been picked and needs allocated to adjustments */
  get excessPickQty(): number {
    // picked greater than the open quantity
    // i.e. Pick==6 and Open (without this piece)==5; Open (with this piece)==-1 return 1;
    let openQty = this.detail.OpenQty;
    if (openQty < 0) return -openQty;

    // picked quantity greater than the piece size
    // i.e. Pick==32, source.OnHand==30, source.QtyAvailableForShipment (with this piece)==-2 return 2;
    let qtyAvail = this.source.QtyAvailable;
    if (qtyAvail < 0) return -qtyAvail;

    return 0;
  }
  /** return a value indicating if the current Pick Details are 'balanced' and the [OK] can be clicked */
  get currentAllocationAcceptable(): boolean {
    if (!this.source.AdjustmentAcceptable) return false;

    if (!this.detail.ShipFullRolls) {
      // when editing an established pick, and the roll-out adjustment is required, do not allow the user to clear it
      // (if not editing established, the adjustment will be required from the restock dialog)
      if (this.editingEstablishedPick && this.source.rolloutRequired && this.source.AdjustmentQty === undefined) return false;
    }

    // also ensure the picked quantity balances with order plus allowances
    return this.detail.ShipFullRolls || (this.openOrderQty + this.allocation.AllowanceQty >= (this.allocation.Qty || 0));
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) data: {
      allocation: ShipmentDetailAllocation,
      editingEstablishedPick: boolean
    },
    public dialogRef: MatDialogRef<PickDetailEditorComponent>,
  ) {
    this.allocation = data.allocation;
    this.editingEstablishedPick = data.editingEstablishedPick;

    // this.doAdjustment = this.source.AdjustmentQty !== undefined;
    // if (this.doAdjustment) this.adjustRemainderTo = (this.source.QtyOnHand + (this.source.AdjustmentQty || 0)).toString();
  }

  debug() {
    console.warn({
      source: this.source,
      detail: this.detail,
      allocation: this.allocation,
      openOrderQty: this.openOrderQty,
      currentAllocationAcceptable:
        '(' + this.openOrderQty + ' + ' + this.allocation.AllowanceQty + ' == ' + this.allocation.Qty + ') == ' + this.currentAllocationAcceptable,
    });
  }

  /** invoked by the slider controls within the editor */
  onSliderChange(sliderID: string, qtyField?: HTMLInputElement) {
    // update the appropriate property on the allocation object
    (<any>this.allocation)[sliderID + 'Qty'] = this.excessPickQty;

    if (sliderID == 'EOR' || sliderID == 'FUL') {
      this.source.AdjustRemainderTo = 0;
    }

    // set focus to the quantity field
    if (qtyField) this.setFocusToInputElement(qtyField);
  }

  /** set focus to the indicate HTMLInputElement and select any text in it */
  setFocusToInputElement(inputElement: HTMLInputElement) { setTimeout(() => { inputElement.focus(); inputElement.select(); }); }

  /** event handler for user clicking the [OK] button */
  onOKButtonClick() {
    this.dialogRef.close(true);
  }

  /** event handler for user clicking the [Delete] button */
  onDeleteAllocationButtonClick() {
    this.dialogRef.afterClosed().subscribe(() => {
      // allocation deleted following afterClosed() so Template binding is connected before object deleted
      this.allocation.delete();
    });

    this.dialogRef.close(false);
  }

}